<template>
    <div>
        <div class="section-loading-screen" v-if="showLoading">
            <div class="section-loading-bubbles">
                <span class="d1"></span>
                <span class="d2"></span>
                <span class="d3"></span>
                <span class="d4"></span>
            </div>
        </div>
        <div class="dev-building-actions">
          <a :href="`/developer/${projectId}/add-project-step2?type=apartment`" class="general-btn positive-btn" v-if="canManage">
            <span> Adauga Model </span>
          </a>
          <a href="javascript:void(0)" @click="openAddBuildingModal(projectId)" class="general-btn positive-btn" v-if="canManage">
              <span> Adauga Bloc </span>
          </a>
        </div>
        <div class="pdetail-group-filters">
          <div class="project-dropdown">
            <div class="project-dropdown__button" @click="flatDropdown = !flatDropdown; roomDropdown = false">
              <i class="fad fa-city"></i>
              <div class="project-dropdown__title">Alege bloc</div>
              <i class="fas fa-caret-down" v-if="!flatDropdown"></i>
              <i class="fas fa-caret-up" v-else></i>
            </div>
            <div class="project-dropdown__counter" v-if="buildingsFilter.length > 0">
              {{buildingsFilter.length}}
            </div>
            <div class="project-dropdown__menu" v-if="flatDropdown">
              <div class="project-dropdown__item" v-for="(building, key) in buildings" :key="key">
                <input type="checkbox"
                  :id="`modelApartmentPanelblockId${building.id}`"
                  :value="building"
                  class="project-dropdown__input"
                  v-model="buildingsFilter"
                  @change="changeBuildingsFilter()">
                <label :for="`modelApartmentPanelblockId${building.id}`" class="project-dropdown__label">
                  <span>Bloc {{ building.name }}</span>
                  <span>{{ building.items_count }}</span>
                </label>
              </div>
              <div class="project-dropdown__item project-dropdown__item--empty" @click="flatDropdown = false" v-if="buildings.length == 0">
                <label class="project-dropdown__label">
                  <span>
                    Nu exista filtre disponibile
                  </span>
                </label>
              </div>
              <div class="project-dropdown__close" @click="flatDropdown = false">
                <i class="fas fa-times"></i>
              </div>
            </div>
          </div>

          <div class="project-dropdown">
            <div class="project-dropdown__button" @click="roomDropdown = !roomDropdown; flatDropdown = false">
              <i class="fad fa-columns"></i>
              <div class="project-dropdown__title">Alege numar camere</div>
              <i class="fas fa-caret-down" v-if="!roomDropdown"></i>
              <i class="fas fa-caret-up" v-else></i>
            </div>
            <div class="project-dropdown__counter" v-if="roomsCountFilter.length > 0">
              {{roomsCountFilter.length}}
            </div>
            <div class="project-dropdown__menu" v-if="roomDropdown">
              <div class="project-dropdown__item" v-for="(value, key) in roomsCount" :key="key">
                <input type="checkbox"
                  :id="`roomId${value.id}`"
                  class="project-dropdown__input"
                  :value="value.id"
                  v-model="roomsCountFilter"
                  @change="changeRoomsCountFilter()"
                />
                <label :for="`roomId${value.id}`" class="project-dropdown__label">
                  <span>{{ value.name }}</span>
                  <span>{{getNumberOfItemsPerRoomCount(value.id)}}</span>
                </label>
              </div>
              <div class="project-dropdown__item project-dropdown__item--empty" @click="roomDropdown = false" v-if="roomsCount.length == 0">
                <label class="project-dropdown__label">
                  <span>
                    Nu exista filtre disponibile
                  </span>
                </label>
              </div>
              <div class="project-dropdown__close" @click="roomDropdown = false">
                <i class="fas fa-times"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="project-grid-container">
          <div class="project-card" v-for="(model, key) in displayModels" :key="key">
            <div class="project-card__name">
              <i class="fad fa-layer-group"></i>
              <a :href="`/developer/project/${projectId}/model/${model.id}/details?client=${urlParams.client}`" v-if="urlParams && urlParams.client">
                {{ model.rooms_count ? model.rooms_count.name : '' }} tip {{ model.model_type }}
              </a>
              <a :href="`/developer/project/${projectId}/model/${model.id}/details`" v-else>
                {{ model.rooms_count ? model.rooms_count.name : '' }} tip {{ model.model_type }}
              </a>
            </div>
            <div class="project-card__info">
              <span>Suprafata Totala</span>
              <span>{{ model.useful_surface }} (m²)</span>
            </div>
            <div class="project-card__info" v-if="model.terrace_surface">
              <span>Suprafata Balcon</span>
              <span>{{ model.terrace_surface }} (m²)</span>
            </div>
            <div class="project-card__info">
              <span>Pret de la</span>
              <span>{{ formatPrice(model.min_price) }}</span>
            </div>
            <div class="project-card__info">
              <span>Pret cu credit de la</span>
              <span v-if="model.min_credit_price"> {{ formatPrice(model.min_credit_price) }}</span>
              <span v-else>&nbsp;</span>
            </div>
            <div class="project-card__info">
              <span>Disponibilitate</span>
              <span>{{ model.items_count }}</span>
            </div>
            <div class="project-card__published" v-if="model.publish">
              Publicat
            </div>
            <div class="project-card__published project-card__published--not" v-else>
              Nepublicat
            </div>
            <div class="project-card__buttons">
              <a :href="`/developer/${projectId}/${model.id}/add-project-step3`" class="project-card__button" data-toggle="tooltip" data-placement="top" title="Adauga Disponibilitati">
                <i class="fas fa-building"></i>
              </a>
              <a :href="`/developer/${model.project_id}/model/${model.id}/edit`" class="project-card__button" data-toggle="tooltip" data-placement="top" title="Modifica Model">
                <i class="fas fa-edit"></i>
              </a>
              <a href="javascript:void(0)" v-if="model.total_items == 0" @click="deleteModel(model.id)" class="project-card__button project-card__button--delete"  data-toggle="tooltip" data-placement="top" title="Sterge Model">
                <i class="fas fa-trash"></i>
              </a>
              <a href="javascript:void(0)" class="project-card__button project-card__button--delete" @click="alertDelete()" data-toggle="tooltip" data-placement="top" title="Sterge Model" v-else>
                <i class="fad fa-trash-alt"></i>
              </a>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: "DeveloperListApartmentModels",
    props: ['projectId','roomsCountList','canManage'],
    // props: {
    //   projectId: Number,
    //   roomsCountList: Array,
    //   canManage: Boolean
    // },
    components: {
      // editor
    },
    data() {
      return {
        showLoading: false,
        roomsCount: [],
        buildings: [],
        buildingsFilter: [],
        roomsCountFilter: [],
        models: [],
        urlParams: null,
        buildId:null,
        flatDropdown: false,
        roomDropdown: false
      }
    },
    async mounted() {
      this.urlParams = window.getAllUrlParams();
      await this.getBuildings()
      await this.getModels()
    },
    computed: {
      displayModels(){
        let output = []
        for(let i in this.models){
          if(this.passFilter(this.models[i])){
            output.push(this.models[i])
          }
        }
        return output
      }
    },
    methods: {
      getBuildings() {
        let vm = this
        vm.showLoading = true
        window.axios.get(`/ajax/get-buildings-by-model-type/${this.projectId}/apartment`)
          .then(function (resp) {
            vm.buildings = resp.data.data
            vm.showLoading = false
          })
          .catch(function () {
            vm.showLoading = false
            // window.showError(err)
          });
      },
      alertDelete() {
        window.Swal.fire({
            title: 'Nu poti sterge acest model',
            text: "Daca doriti sa stergeti acest model mai intrai trebuie sa stergeti toate apartamentele",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Da, am inteles!',
          })
      },
      alertDeleteBuilding() {
        window.Swal.fire({
            title: 'Nu poti sterge acest bloc',
            text: "Daca doriti sa stergeti acest bloc mai intrai trebuie sa stergeti toate apartamentele",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Da, am inteles!',
          })
      },
      getModels() {
        let vm = this
        vm.showLoading = true
        window.axios.get(`/ajax/developer/get-models/${this.projectId}/apartment`)
          .then(function (resp) {
            vm.models = resp.data.data
            vm.models.sort(function(a, b) { return a.rooms_count.sort_order - b.rooms_count.sort_order})
            for(let i in vm.models) {
              let roomCountObj = vm.roomsCountList.find(r => r.id === vm.models[i].rooms_count_id)
              if(!vm.roomsCount.includes(roomCountObj)){
                vm.roomsCount.push(roomCountObj)
              }
              vm.roomsCount.sort(function(a, b) { return a.sort_order - b.sort_order})
            }
            vm.showLoading = false
          })
          .catch(function () {
            vm.showLoading = false
            // window.showError(err)
          });
      },
      passFilter(model) {
        if(this.buildingsFilter.length > 0){
          let includes = false
          for(let i in this.buildingsFilter) {
            if(model.buildings.find(b => b.id === this.buildingsFilter[i].id)){
              includes = true
              break
            }
          }
          if(!includes) return false
        }

        if (this.roomsCountFilter.length > 0 && !this.roomsCountFilter.includes(model.rooms_count_id)){
          return false
        }

        return true
      },
      changeBuildingsFilter() {
        let vm = this
        this.showLoading = true
        let buildings = _.map(this.buildingsFilter, 'id');
        vm.roomsCount = []
        if(buildings.length > 0) {
          vm.models.filter(m => (m.buildings.filter(x => buildings.includes(x.id)).length > 0)).forEach(function (model) {
            let roomCountObj = vm.roomsCountList.find(r => r.id === model.rooms_count_id)
            if(!vm.roomsCount.includes(roomCountObj)){
              vm.roomsCount.push(roomCountObj)
            }
            vm.roomsCount.sort(function(a, b) { return a.sort_order - b.sort_order})
          });
        } else {
          vm.models.forEach(function (model) {
            let roomCountObj = vm.roomsCountList.find(r => r.id === model.rooms_count_id)
            if(!vm.roomsCount.includes(roomCountObj)){
              vm.roomsCount.push(roomCountObj)
            }
            vm.roomsCount.sort(function(a, b) { return a.sort_order - b.sort_order})
          });
        }
        setTimeout(function(){ vm.showLoading = false }, 500);
      },
      changeRoomsCountFilter() {
        let vm = this
        this.showLoading = true
        setTimeout(function(){ vm.showLoading = false }, 500);
      },
      getNumberOfItemsPerRoomCount(roomCountId) {
        let buildings = _.map(this.buildingsFilter, 'id');
        let models = []
        if (buildings.length > 0) {
          models = this.models.filter(m => (m.rooms_count_id === roomCountId && m.buildings.filter(x => buildings.includes(x.id)).length > 0))
        } else {
          models = this.models.filter(m => (m.rooms_count_id === roomCountId))
        }
        // console.log(models);
        let sum = 0;
        let nr = 0;
        models.forEach(function(model){
          if (buildings.length > 0) {
            nr = model.items.filter(item => item.status === 'available' && buildings.includes(item.project_building_id));
            sum += parseInt(nr.length)
          } else {
            nr = model.items.filter(item => item.status === 'available');
            sum += parseInt(nr.length)
          }
        })
        return sum;
      },
      getNrDisponibleModelItems(model) {
        let buildings = _.map(this.buildingsFilter, 'id');
        let sum = 0;
        let nr = 0;
        if (buildings.length > 0) {
          nr = model.items.filter(item => item.status === 'available' && buildings.includes(item.project_building_id));
          sum += parseInt(nr.length)
        } else {
          nr = model.items.filter(item => item.status === 'available');
          sum += parseInt(nr.length)
        }
        return sum;
      },
    }
  }
</script>
